module.exports = __webpack_public_path__ + "static/img/fallecido.9b481d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fallecido.png
// module id = ZmUu
// module chunks = 9